export default "__VITE_PUBLIC_ASSET__b3505544__"